import { useState, useRef, useEffect } from 'react';
import { Info } from 'lucide-react';

interface InfoTooltipProps {
  text: string;
}

export default function InfoTooltip({ text }: InfoTooltipProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="relative inline-flex" ref={ref}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        onMouseEnter={() => setOpen(true)}
        className="text-sereno-dark/30 hover:text-sereno-dark/70 transition-colors"
        aria-label="Información"
      >
        <Info size={13} />
      </button>
      {open && (
        <div
          className="absolute z-40 right-0 top-5 w-60 p-2.5 bg-sereno-dark text-white text-xs leading-relaxed rounded-lg shadow-xl"
          onMouseLeave={() => setOpen(false)}
        >
          {text}
        </div>
      )}
    </div>
  );
}
